export default __webpack_public_path__ + "static/natural-7202700e673ab05f308345640b23c605.jpg";